<template>
	<div>
		<a-row>
			<a-col :span="10">
				<br />
				<a-form :form="form">
					<a-form-item :label-col="{ span: 4 }" :wrapper-col="{ span: 8 }" label="分类标签">
						<a-input v-decorator="['area', { rules: [{ required: true, message: '请输入分类标签' }] }]" placeholder="请输入店铺名称" />
						<a-button
							type="primary"
							@click="addArae()"
						>
							添加分类
						</a-button>
					</a-form-item>
				</a-form>
				<div v-for="(item,index) in areaArray" :key="index" style="float: left; margin-left: 20px;margin-top: 10px;">
					<span >
						
						<a-card title="分类" style="width: 300px">
							<span slot="extra" >
								<a-popconfirm title="你确定要删除这个客服吗?" @confirm="confirm(item.id)" @cancel="cancel(item.id)" okText="Yes" cancelText="No">
									<a href="#">删除</a>
								</a-popconfirm>
							</span>
							<h2 style="color: red">{{item.name}}</h2>
						</a-card>
						
					</span>
				</div>
			</a-col>
			<a-col :span="10" class="preview_phone"></a-col>
			<a-col :span="4"></a-col>
		</a-row>
	</div>
</template>
<script>
import api from '../../api/Api.js';
export default {
	data() {
		return {
			visible: true,
			form: this.$form.createForm(this, { name: 'dynamic_rule' }),
			areaArray:[{
				"id": 1,
				"name": "东区"
			},
			{
				"id": 2,
				"name": "西区"
			}],
			page:0
		};
	},
	mounted() {
		this.getClassifyList();
	},
	methods:{
		getClassifyList(){
			const that = this;
			let url = 'api/commerce/v1/admin/classifyList';
			let parm = {
				page: this.page
			};
			api.postRequest(url, parm, res => {
				console.log(res);
					
				const rest = res.data;
				if (rest.status == 200) {
					
					that.areaArray = rest.data;
					console.log("=====================")
					console.log(that.areaArray)
					console.log("=====================")
					
				} else {
					this.$message.error('服务器内部错误！');
				}
			});
		},
		addArae(){
			
			if(this.form.getFieldsValue().area){
				var that = this;
				
				let url = 'api/commerce/v1/admin/addClassify';
				let parm = {
					name: that.form.getFieldsValue().area
				}
							
				api.postRequest(url, parm, res => {
					const rest = res.data;
					if (rest.status == 200) {
						
						that.addCompanyStyleWindow = false;
						that.getClassifyList();
						that.form.resetFields();
						this.$message.success('添加成功！');
					} else {
						this.$message.error('服务器内部错误！');
					}
				});
			}else{
				this.$message.error('请输入分类！');
			}
			
		},
		confirm(id) {
			const that = this;
			let url = 'api/commerce/v1/admin/deleteClassify';
			let parm = {
				id: id
			};
			api.postRequest(url, parm, res => {
				const rest = res.data;
				if (rest.status == 200) {
					this.$message.success('删除成功！');
					that.getClassifyList();
				} else {
					this.$message.error(rest.message);
				}
			});
			
		},
		cancel(e) {
			this.$message.error('取消');
		},
	}
};
</script>
